import { render, staticRenderFns } from "./AddAnnoucementModal.vue?vue&type=template&id=0e51fa5d"
import script from "./AddAnnoucementModal.vue?vue&type=script&lang=js"
export * from "./AddAnnoucementModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports